import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { buttons as Buttons, buttonsV2 as ButtonsV2 } from '@breezeway/brzw-components';

import './date_switch.scss';

class DateSwitch extends Component {
  constructor(props) {
    super(props);

    this.CLASS_NAME = 'date-switch';
    this.NEXT_KEY = 'next';
    this.PREV_KEY = 'prev';

    this.onButtonClick = this.onButtonClick.bind(this);
    this.renderButton = this.renderButton.bind(this);
    this.renderReversion = this.renderReversion.bind(this);
  }

  onButtonClick(direction) {
    return () => {
      const { onPreviousClick, onNextClick } = this.props;

      switch (direction) {
        case this.PREV_KEY:
          onPreviousClick();

          break;
        case this.NEXT_KEY:
          onNextClick();

          break;
        default:
          break;
      }
    };
  }

  renderButton(direction) {
    const { newHeader } = this.props;
    const buttonProps = {
      className: `${this.CLASS_NAME}__direction-button`,
      iconName: direction === this.NEXT_KEY ? 'chevron-right' : 'chevron-left',
      onClick: this.onButtonClick(direction),
    };

    if (newHeader) {
      return (
        <ButtonsV2.IconButton
          size={ButtonsV2.constants.BUTTON_SIZES.ICON_MEDIUM}
          theme={ButtonsV2.constants.BUTTON_THEMES.SUBTLE}
          {...buttonProps}
        />
      );
    }

    return (
      <Buttons.IconButton
        size={Buttons.constants.BUTTON_SIZES.ICON_X_SMALL}
        theme={Buttons.constants.BUTTON_THEMES.LINK}
        {...buttonProps}
      />
    );
  }

  renderReversion() {
    const { buttonText, onReversionClick, newHeader } = this.props;

    if (!buttonText) {
      return null;
    }

    const buttonProps = {
      autoWidth: true,
      className: `${this.CLASS_NAME}__reversion-button`,
      onClick: onReversionClick,
    };

    if (newHeader) {
      return (
        <ButtonsV2.TextButton theme={ButtonsV2.constants.BUTTON_THEMES.DEFAULT} {...buttonProps}>
          {buttonText}
        </ButtonsV2.TextButton>
      );
    }

    return (
      <Buttons.TextButton theme={Buttons.constants.BUTTON_THEMES.SECONDARY} {...buttonProps}>
        {buttonText}
      </Buttons.TextButton>
    );
  }

  render() {
    const { containerClassName: propsContainerClassName, withoutLayoutBox, newHeader } = this.props;

    const containerClassName = classnames(this.CLASS_NAME, propsContainerClassName, {
      'layout-box l__has-columns l__align-center': !withoutLayoutBox,
      [`${this.CLASS_NAME}--new-header`]: newHeader,
    });

    return (
      <div className={containerClassName}>
        {this.renderReversion()}
        {this.renderButton(this.PREV_KEY)}
        {this.renderButton(this.NEXT_KEY)}
      </div>
    );
  }
}

DateSwitch.propTypes = {
  buttonText: PropTypes.string,
  containerClassName: PropTypes.string,
  newHeader: PropTypes.bool,
  onNextClick: PropTypes.func.isRequired,
  onPreviousClick: PropTypes.func.isRequired,
  onReversionClick: PropTypes.func,
  withoutLayoutBox: PropTypes.bool,
};

DateSwitch.defaultProps = {
  buttonText: '',
  containerClassName: '',
  onReversionClick: () => {},
  withoutLayoutBox: false,
};

export default DateSwitch;
